
import { convertWeight } from "../../../utils/common";

const LBS_TO_KG_FACTOR = 0.453592;

export class Weight {
    constructor(weight, unit = 'lbs') {
        this.weight = parseFloat(weight);
        this.unit = unit;
    }
    create(weight) {
        let weightObj = weight
        if (typeof weight === 'string') {
            weightObj = JSON.parse(weight);
        }
        return new Weight(weightObj.weight, weightObj.unit);
    }

    getWeightWithUnitKG() {
        if (this.unit === 'lbs') {
            return (this.weight * LBS_TO_KG_FACTOR).toFixed(2);
        } else {
            return this.weight;
        }
    }
    toPlainObject() {
        return  {
            weight: this.weight,
            unit: this.unit
        };
    }
    getUnit() {
        if (this.unit === "lbs") {
            return 1;
        }
        return 0;
    }

    // 单位转换方法 - 使用utils中的转换函数
    convertWeight(value, fromUnit, toUnit) {
        return convertWeight(value, fromUnit, toUnit);
    }

    // 转换当前实例的单位
    convertToUnit(newUnit) {
        if (this.unit === newUnit) return this;
        
        const newWeight = convertWeight(this.weight, this.unit, newUnit);
        
        return new Weight(newWeight, newUnit);
    }

}

export default Weight;